/**
 * @desc 下载导入发货需求模板
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/importTemplate`, {
      method: "GET",

      ...options,
    }),
  );
}
